import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendCommand, subscribeToSessionStatus, connectWebSocket } from '../websocketService';
import Janus from 'janus-gateway'; 
import adapter from 'webrtc-adapter'; 
window.adapter = adapter; // Ensure adapter is available globally if Janus expects it

const HomePage = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.name : `User${Math.floor(Math.random() * 1000)}`;
  });

  const [generatedId, setGeneratedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [customSessionId, setCustomSessionId] = useState('');
  const rtcSessionMetadata = useRef(null);
      
  /*useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user) {
        navigate('/login');
      } else {
        setUserName(user.name);
      }
    }, [navigate]);*///Validate user login

    // Initialize Janus only once when the component mounts
  useEffect(() => {
    if (!Janus.initialized) {
      Janus.init({ debug: "all", callback: () => {
        Janus.initialized = true;
        console.log("Janus initialized");
      }});
    }
    connectWebSocket(); // Connect WebSocket early
    return () => {      
      // disconnectWebSocket is handled implicitly by STOMP client reconnectDelay
      // but you could add an explicit disconnect here if needed.
    };
  }, []);


    const handleCreateRoom = () => {
      setLoading(true);
      setError('');
      sendCommand('/session/start', { userId: userName });    
    };

  
    const handleJoinRoom = () => {       
      if(customSessionId) {
      //sendCommand('/session/join', {customSessionId: customSessionId, userId: userName});
          navigate(`/connecting/${customSessionId}`);
      } else {
        setError('Please enter a Room ID to join.');
      }
  };

    // Validate session data 
    useEffect(() => {
      let subscription = null;
      connectWebSocket()
          .then(() => {            
            subscription = subscribeToSessionStatus((response) => {
              console.log("response: " , response);
              setLoading(false);

              if(response.status){
                const sessionMetadata = response.data; 
                const type = sessionMetadata['type'];     
                
                if (type === "SESSION_STARTED") {
                  // Store session metadata from SESSION_STARTED. Do not navigate yet.
                  setGeneratedId(sessionMetadata['collab-session-metadata']?.customSessionId); // Display generated ID for creator
                  setCustomSessionId(sessionMetadata['collab-session-metadata']?.customSessionId); // Set custom session ID for joining later
                } else if (type === "ROOM_JOINED") {
                    navigate(`/connecting/${customSessionId}`);
                } else {
                  setError('Unknown response type.');
                  console.error('Unknown response type:', response);
                } 

              } else {
                setError(response.message || 'An error occurred while creating room.')
              }            
          });
        })
        .catch((err) => {
          console.error('WebSocket connection failed:', err);
          setError('Failed to connect to server.');
          setLoading(false);
        });

        return () => {
          if (subscription) {
            subscription.unsubscribe(); // Optional cleanup
          }
        };
    }, [navigate, customSessionId]);

    
    
    /*useEffect(() => {
        fetch('https://jsonplaceholder.typicode.com/posts')
          .then((response) => response.json())
          .then((data) => setData(data.slice(0, 5)));
      }, []);*/

  const handleLogout = () => {
    if(window.confirm('Are you sure you want logout?')){
      localStorage.removeItem('token');
      localStorage.removeItem('user');  
      navigate('/login');
    }
  };

  return (    
    <div className="min-h-screen from-sky-950 via-gray-950 to-gray-900 to-black text-white p-4 sm:p-8 flex flex-col items-center justify-center font-sans">
        <nav className="w-full max-w-4xl flex justify-center sm:justify-end space-x-2 sm:space-x-4 mb-8">
            <button onClick={() => navigate('/home')}
              className="px-4 py-2 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
              >
                Home</button>
            <button onClick={() => navigate('/profile')} className="px-4 py-2 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
              >Profile</button>
            <button onClick={() => navigate('/settings')}
              className="px-4 py-2 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
              >Settings</button>
            <button onClick={handleLogout}
            className="px-4 py-2 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
            >Logout</button>
        </nav>

        <div className="bg-gray-800/70 backdrop-blur-lg rounded-2xl shadow-2xl p-6 sm:p-10 text-center w-full max-w-md border border-gray-700/50">
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 text-blue-300">
          Welcome, {userName}!
        </h1>
        <p className="text-lg sm:text-xl text-gray-300 mb-6">
          Ready to connect? Join an audio room:
        </p>
      
        <div className="mb-4">
            <input
            type="text"
            placeholder="Enter Room ID"
            value={customSessionId || ''}
            className="w-full sm:w-auto flex-grow px-5 py-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-lg border border-gray-600"
            required
            onChange={(e)=> setCustomSessionId(e.target.value)}
            />
            <button onClick={handleJoinRoom}
            className="w-full sm:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 text-lg mt-4"
            >
              Join Room
            </button>
        </div>
        <button 
          onClick={handleCreateRoom}
          className="w-full sm:w-auto px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-lg shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75 text-lg mb-6"
          >
            Create Room
        </button>
        
        {generatedId && (
        <div className="mt-6 p-4 bg-gray-700 rounded-lg border border-gray-600 shadow-inner">
          <p className="text-green-400 font-semibold text-lg mb-2">
            Room Created!
          </p>
          <p className="text-gray-300 text-md mb-2">
            Share this ID with your friend: 
            <strong className="block text-xl font-bold text-blue-300 select-all mt-2">
              {generatedId}
            </strong>
          </p>
        </div>
      )}
    {/*<ul>
        {data.map((item) => (
            <li key={item.id}>{item.title}</li>
        ))}
    </ul>*/}
    {loading && (
      <p className="mt-4 text-gray-400 text-lg animate-pulse">
        Loading...
      </p>
    )}
    {error && (
      <p className="mt-4 text-red-500 font-semibold text-lg">
        {error}
      </p>
    )}
    </div>
    </div>
  );
};

export default HomePage;